import { Component, Input, OnInit, Output, SimpleChanges, OnChanges, EventEmitter, forwardRef} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { countries } from '../../../../core/data/prefix/prefix'

/**
   * Logger Factory
   * @namespace chnage: emit the current value of input 
   * @namespace title: title of label
   * @namespace type: is the type of input (text, number, password)
   * @namespace errorMessage: message to show in error case
   * @namespace minLength: min length of value of input value
   * @namespace maxLength: max length of value of input value
   * @namespace changeValue: is the output that take off tio the parent the current value
   * ES:
   * <ute-input-prefix 
   *    label="Numero di telefono"
   *    type="text" errorMessage="Deve contenere almeno 8 caratterei" 
   *    name="+39 |"  
   *    (changeValue)="test($event)"></ute-input-prefix>

*/

@Component({
  selector: 'ute-input-prefix',
  templateUrl: 'ute-input-prefix.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(()=>UteInputPrefixComponent),
    multi: true
  }]
})
export class UteInputPrefixComponent  implements  OnInit, OnChanges, ControlValueAccessor {
  @Input() title: string;
  @Input() label: string;
  @Input() type: string;
  @Input() errorMessage: string;
  @Input() maxlength: string;
  @Input() minlength: string;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() blur: EventEmitter<any> = new EventEmitter<any>(); 
  
  public idInput: string;
  public prefix: string;
  public listPrefix: any;
  
  public value: string = '';
  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };

  constructor() {
    this.prefix = '+39';
    this.listPrefix = countries.map((e) => {
      return `${e.code}`;
    })
  }

  ngOnInit() {
    this.idInput = `input-${this.title}`;
  }

  ngOnChanges(changes: SimpleChanges): void { 
    if (changes && changes.title) {
      this.idInput = `input-${changes.title.currentValue}`;
    }
    if(changes && changes.listPrefix){
      this.listPrefix = changes.listPrefix.currentValue;
    }
  }

  onChange(event) {
    this.value = `${this.prefix} ${event.target.value}`;

    this.propagateChange(this.value);
    this.change.emit(this.value);
  }

  onBlur(event) {
    this.propagateTouch();
    this.blur.emit(event);
  }

  public writeValue(obj: any) {
    if(obj) this.value = obj;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/atoms/ute-input-prefix/ute-input-prefix.component.ts